import { render, staticRenderFns } from "./FamilyList.vue?vue&type=template&id=de4b6bc6&scoped=true"
import script from "./FamilyList.vue?vue&type=script&lang=js"
export * from "./FamilyList.vue?vue&type=script&lang=js"
import style0 from "./FamilyList.vue?vue&type=style&index=0&id=de4b6bc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de4b6bc6",
  null
  
)

export default component.exports